import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Principles from './components/Principles';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import SEO from './components/SEO';
import ServicePage from './components/ServicePage';
import ProjectPage from './components/ProjectPage';
import ProjectsListPage from './components/ProjectsListPage';
import { initGA } from './utils/analytics';

// Home page component
const HomePage = () => (
  <>
    <SEO />
    <Hero />
    <Services />
    <About />
    <Testimonials />
    <Principles />
    <CallToAction />
  </>
);

function App() {
  useEffect(() => {
    // Initialize GA (ensures it's ready for tracking)
    initGA();
  }, []);
  
  // Reset scroll to top when component mounts or serviceId changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/:serviceId" element={<ServicePage />} />
            <Route path="/projects" element={<ProjectsListPage />} />
            <Route path="/projects/:projectId" element={<ProjectPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;